document.addEventListener('DOMContentLoaded', () => {
  const dynamicSEOMetaTag = () => {
    const handleTitleAsOGTitle = () => {
      const title = document.title || '';
      updateMetaTagContent('property','og:title', title);
      updateMetaTagContent('name','twitter:title', title);
  };

  const handleUrlAsOGUrl = () => {
      const url = window.location.href || '';
      updateMetaTagContent('property','og:url', url);
      updateMetaTagContent('name','twitter:url', url);
  };

  const handleDescriptionAsOGDescription = () => {
      const description = getMetaTagContent('description') || '';
      updateMetaTagContent('property','og:description', description);
      updateMetaTagContent('name','twitter:description', description);
  };

  const getMetaTagContent = (name) => {
      const tag = document.querySelector(`meta[name="${name}"]`);
      return tag ? tag.getAttribute('content') : '';
  };

  const updateMetaTagContent = (att,property, content) => {
      const metaTag = document.querySelector(`meta[${att}="${property}"]`);
      if (metaTag) {
          metaTag.setAttribute('content', content);
      }
  };


  handleTitleAsOGTitle();
  handleUrlAsOGUrl();
  handleDescriptionAsOGDescription();
  }
  dynamicSEOMetaTag()
});
